import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { DynamicPropertyEntity } from "../../types/DynamicPropertyEntity";
import { DynamicPropertyDtoToEntity } from "../mappers/DynamicPropertyDtoToEntity";
import { DynamicPropertyEntityToDto } from "../mappers/DynamicPropertyEntityToDto";

const DynamicPropertyApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        DynamicPropertyLoad: builder.query<DynamicPropertyEntity, FormQuery>({
            providesTags: [ResourceName.DYNAMIC_PROPERTIES],
            query: (queryParams) => {
                return {
                    url: `${ResourceName.DYNAMIC_PROPERTIES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return DynamicPropertyDtoToEntity(response);
            },
        }),
        DynamicPropertySave: builder.mutation<DynamicPropertyEntity, FormMutation<DynamicPropertyEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.DYNAMIC_PROPERTIES}`;
                const method = "POST";

                const body = DynamicPropertyEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DYNAMIC_PROPERTIES],
        }),
        DynamicPropertyUpdate: builder.mutation<DynamicPropertyEntity, FormMutation<DynamicPropertyEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.DYNAMIC_PROPERTIES}/${mutation.data.id}`;
                const method = "PUT";

                const body = DynamicPropertyEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DYNAMIC_PROPERTIES],
        }),
    }),
});

export const { useDynamicPropertyLoadQuery, useDynamicPropertySaveMutation, useDynamicPropertyUpdateMutation } = DynamicPropertyApi;
